import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite"
import { useGapDataGridStore } from "./GapDataGridStore"
import { GridOverlay } from "@mui/x-data-grid"

export default observer(function GapDataGridNoRows() {
   const gapDataGridStore = useGapDataGridStore()

   return <GridOverlay>
      <Grid
         container
         spacing={0}
         direction="column"
         alignItems="center"
         justifyContent="center"
      >
         <Grid size={12}>
            <Typography variant="body1" color="text.secondary">{gapDataGridStore.noRowsText}</Typography>
         </Grid>
      </Grid>
   </GridOverlay>
})
